import { ValidateIf, registerDecorator, ValidatorConstraint } from 'class-validator';
import { a as applyDecorators } from './applyDecorators_chunkExport-D6nMF0T1.mjs';

function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function IsOptional(options, validationOptions) {
    return applyDecorators(ValidateIf((_, value)=>{
        const { isNil, correct } = isNilCorrect(value, options);
        if (isNil) return !correct;
        return true;
    }), (object, propertyName)=>{
        registerDecorator({
            target: object.constructor,
            propertyName: propertyName,
            options: validationOptions,
            validator: IsOptionalValidator,
            constraints: [
                options
            ]
        });
    });
}
const isOptionalValidatorName = "CustomIsOptional";
class IsOptionalValidator {
    validate(value, { constraints: [options] }) {
        const { correct } = isNilCorrect(value, options);
        return correct;
    }
}
IsOptionalValidator = _ts_decorate([
    ValidatorConstraint({
        name: isOptionalValidatorName
    })
], IsOptionalValidator);
function isNilCorrect(value, options) {
    const { allowUndefined = true, allowNull = true } = options ?? {};
    const isUndefined = value === undefined;
    if (isUndefined && !allowUndefined) return {
        correct: false,
        isNil: true
    };
    const isNull = value === null;
    if (isNull && !allowNull) return {
        correct: false,
        isNil: true
    };
    return {
        correct: true,
        isNil: isUndefined || isNull
    };
}
function getIsOptionalDescription(nullAllow, undefinedAllow) {
    return `Можно передать null - ${nullAllow ? "да" : "нет"}; Можно не передать вообще - ${undefinedAllow ? "да" : "нет"}`;
}
function getIsOptionalSchema(constraints) {
    const [options] = constraints;
    if (!options) return {
        nullable: true,
        description: getIsOptionalDescription(true, true)
    };
    return {
        nullable: options.allowNull || options.allowUndefined,
        description: getIsOptionalDescription(options.allowNull ?? true, options.allowUndefined ?? true)
    };
}

export { IsOptional as I, getIsOptionalSchema as g, isOptionalValidatorName as i };
//# sourceMappingURL=isOptional_chunkExport-C6McH_Jl.mjs.map
